import RuleParameterAlias from './rule-parameter-alias.entity';

export default class ItemRuleAliasSummary {
  itemRuleId: string;

  alias: string;

  currentAlias: string;

  hasCustomAlias: boolean = false;

  parameters: RuleParameterAlias[];

  constructor(obj: any) {
    this.itemRuleId = obj.itemRuleId || '';
    this.currentAlias = obj.alias || '';
    this.alias = obj.alias || '';
    this.hasCustomAlias = obj.hasCustomAlias;
    this.parameters = obj.parameters ? RuleParameterAlias.ofList(obj.parameters) : [];
  }

  static of(obj: any): ItemRuleAliasSummary {
    return new ItemRuleAliasSummary(obj || {})
  }

  static ofList(obj: any[]): ItemRuleAliasSummary[] {
    return obj.map(this.of)
  }
}
